import { SEARCH_UI_LOADED, SEARCH_UI_UNABLE_TO_LOAD } from "../types";

export default function uiDataReducer(state = {}, action = {}) {
  switch (action.type) {
    case SEARCH_UI_LOADED: {
      return action.uiData;
    }
    case SEARCH_UI_UNABLE_TO_LOAD: {
      return { ...state, ...action.uiData };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/uiData.js